export default __webpack_public_path__ + "static/latency2-4a5ebbbbbda495a220b6e299c17c058b.png";